import DataVisualizationBase, * as DataVisualization from '@segment/matcha/recipes/DataVisualization'

import MaturityModelImageLg from './assets/MaturityModelImageLg.png'
import MaturityModelImageSm from './assets/MaturityModelImageSm.png'

export const sources = {
  src: { name: MaturityModelImageLg, width: 1281, height: 695 },
  xs: { name: MaturityModelImageSm, width: 655, height: 370 },
  lg: { name: MaturityModelImageLg, width: 1281, height: 695 },
}

const copy = {
  heading: `Maturity model overview`,
}

const ActImage = () => (
  <DataVisualizationBase>
    <DataVisualization.Heading>{copy.heading}</DataVisualization.Heading>
    <DataVisualization.Figure>
      <DataVisualization.Image
        sources={sources}
        alt={`Illustration: ${copy.heading}`}
        width={640}
        height={411}
        unoptimized={true}
      />
    </DataVisualization.Figure>
  </DataVisualizationBase>
)

export default ActImage
